module.exports = __webpack_public_path__ + "static/media/icon.52e3d305.png";